import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Compass, ShieldAlert } from "lucide-react";
import { longDay, money } from "@/lib/daytime";
import { ADDON_META } from "@/lib/addons";

function ExtraHelp({ onAddon }) {
  return (
    <div data-testid="rock-ready-extra-help">
      <p className="text-xs font-bold text-navy mb-1">WOULD YOU LIKE TO ADD A LITTLE EXTRA HELP?</p>
      <div className="grid grid-cols-2 gap-1.5">{Object.entries(ADDON_META).map(([k, m]) => { const I = m.icon; return (
        <button key={k} onClick={() => onAddon(k)} className="text-left rounded-xl border border-slate-200 px-2 py-2 hover:border-turquoise" data-testid={`rock-ready-addon-${k}`}>
          <p className="text-xs font-bold text-navy flex items-center gap-1"><I className="w-4 h-4" style={{ color: m.color }} /> {m.name}</p>
          <p className="text-[10px] text-slate-500 leading-tight">{m.sub}</p><p className="text-[10px] font-bold text-turquoise mt-0.5">ADD TO BOOKING</p>
        </button>); })}</div>
    </div>
  );
}

export function RockReadyDialog({ result, settings, onClose, onPay, onAddon }) {
  return (
    <Dialog open={!!result} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md max-h-[92vh] overflow-y-auto" data-testid="rock-ready-dialog">
        <DialogHeader><DialogTitle className="font-display text-navy text-xl flex items-center gap-2"><Compass className="w-6 h-6 text-turquoise" /> YOUR EXPLORER IS ROCK READY!</DialogTitle></DialogHeader>
        <div className="space-y-2 max-h-56 overflow-y-auto">
          {result?.bookings.map((b) => (
            <div key={b.id} className="bg-slate-50 rounded-xl px-3 py-2 text-sm" data-testid={`rock-ready-row-${b.id}`}>
              <p className="font-bold text-navy">{b.child_name} · {longDay(b.date)}</p>
              <p className="text-slate-500 text-xs">{b.type_label}{b.price ? ` · ${money(b.price)}` : ""}</p>
            </div>
          ))}
        </div>
        <div className="text-sm text-slate-600 space-y-1">
          <p><b>Arrival window:</b> {settings.hours}</p>
          <p><b>Location:</b> {settings.location}</p>
        </div>
        <p className="flex items-start gap-2 bg-coral/10 text-coral rounded-xl px-3 py-2 text-sm font-semibold"><ShieldAlert className="w-4 h-4 mt-0.5 shrink-0" /> Parent/Guardian must remain on-site during Daytime Open Play.</p>
        {result && onAddon && <ExtraHelp onAddon={onAddon} />}
        {result?.order ? (
          <Button onClick={onPay} className="w-full rounded-full bg-gold text-navy font-bold h-12" data-testid="rock-ready-pay">Pay {money(result.order.amount)} now</Button>
        ) : (
          <Button onClick={onClose} className="w-full rounded-full bg-navy text-white font-bold h-12" data-testid="rock-ready-done">Done</Button>
        )}
        {result?.credit_applied > 0 && <p className="text-xs text-emerald-600 text-center">{money(result.credit_applied)} Daytime credit applied</p>}
      </DialogContent>
    </Dialog>
  );
}

export function PassReadyDialog({ open, onClose, onChoose }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-sm text-center" data-testid="pass-ready-dialog">
        <DialogHeader><DialogTitle className="font-display text-navy text-xl text-center">YOUR ROCK PASS IS READY!</DialogTitle></DialogHeader>
        <p className="text-slate-600">WOULD YOU LIKE TO BOOK YOUR FIRST PLAY DAYS?</p>
        <Button onClick={onChoose} className="w-full rounded-full bg-gold text-navy font-bold h-12" data-testid="pass-ready-choose">YES — CHOOSE MY DAYS</Button>
        <button onClick={onClose} className="text-sm text-slate-400" data-testid="pass-ready-later">Maybe later</button>
      </DialogContent>
    </Dialog>
  );
}
